export const ASSETS = {
  logo: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/cbfc10548a95279b53dfedb077aba7320c3bb817bcefc117c6e72a921567455e.jpeg",
  hero: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/248ba2d7f86820a6b78ea880a1b0d0bb4838442944860dbfb6d30ec46f3d94b6.jpeg",
  product: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/5e80785f04e2459e1f9ef5e07ec316e035d0a1b8dda6d56b99bc53062754bf99.jpeg",
  family: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/1066b793200dd0b667ccb5ef37e8ccfcd42bdda15bd689e264a75c2b5922d7f0.jpeg",
  solarHouse: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?w=1200&q=80",
  business: "https://images.unsplash.com/photo-1687422808311-a776f467a468?w=1000&q=80",
};

// Campaign films — swap these with the real Gesung films anytime.
// webm (VP9) + mp4 (H.264) sources for maximum browser compatibility.
export const VIDEOS = [
  {
    webm: "https://media.w3.org/2010/05/sintel/trailer.webm",
    mp4: "https://videos.pexels.com/video-files/13198260/13198260-hd_1920_1080_24fps.mp4",
    poster: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/5dd7e83d02f71b54fe84073db5cf7da3e9fbe38ab2201454a7c1e5a6f736a2fa.jpeg",
  },
  {
    webm: "https://media.w3.org/2010/05/video/movie_300.webm",
    mp4: "https://videos.pexels.com/video-files/2804599/2804599-hd_1920_1080_24fps.mp4",
    poster: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/1570d14fcdf81b5046c2af10a120feaa9205fc711f1264812d82d5e6efce0243.jpeg",
  },
  {
    webm: "https://test-videos.co.uk/vids/bigbuckbunny/webm/vp9/360/Big_Buck_Bunny_360_10s_1MB.webm",
    mp4: "https://videos.pexels.com/video-files/2804599/2804599-hd_1920_1080_24fps.mp4",
    poster: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/8478328f8d4f73fad7d034d6935b6088d5c26fc9cc3bebd530ad32ad1fda0233.jpeg",
  },
  {
    webm: "https://test-videos.co.uk/vids/jellyfish/webm/vp9/360/Jellyfish_360_10s_1MB.webm",
    mp4: "https://videos.pexels.com/video-files/13198260/13198260-hd_1920_1080_24fps.mp4",
    poster: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/0ec14e1b1a45cf17052c2f4be74a80622f2e14a8eafd8707034f63c73565cd37.jpeg",
  },
  {
    // Slot 04 — Silent Green vs Diesel comparison (upload the real clip in Admin → Films)
    mp4: "https://videos.pexels.com/video-files/2804599/2804599-hd_1920_1080_24fps.mp4",
    poster: "https://static.prod-images.emergentagent.com/jobs/bcaa6402-d148-46bb-b5ef-f49ac1940dcd/images/1775ebe3f4d6b24f30ebf65d51c816de0296ba55567fa6e81a943faabfd01e1b.jpeg",
  },
];

// Index of the Silent-Green-vs-Diesel comparison film in VIDEOS / film slots.
export const VERSUS_FILM_INDEX = 4;

// Live "fuel burning right now" ticker assumptions for the Silent-vs-Diesel section.
// A mid-size diesel genset under load; figures in USD (converted to local currency via fx).
export const DIESEL = {
  litresPerHour: 4,     // litres consumed per running hour under load
  usdPerLitre: 1.1,     // approx pump price (USD)
  hoursPerDay: 8,       // typical daily backup runtime
};
export const dieselUsdPerHour = () => DIESEL.litresPerHour * DIESEL.usdPerLitre; // ≈ 4.4
export const dieselAnnualUsd = () => dieselUsdPerHour() * DIESEL.hoursPerDay * 365;

// Real Gesung product line (USD, from 2025 price list). fx applied per region for local pricing.
// specs mapped directly from the Gesung 2025 catalog (Power Storage Generator Series).
export const PRODUCTS = [
  {
    model: "GP3000", kw: 3, usd: 2521.21, use: "Residential backup / small irrigation", budget: "under_2k", maxUsd: 100,
    img: "/images/gp3000.jpg", pdf: "/datasheets/gp3000.pdf", pvUsd: 690,
    specs: { rated: "3,000 W", peak: "6,000 W", battery: "3,136 Wh", chem: "LiFePO4", voltage: "44.8 V", charge: "≤ 2 h", wave: "Pure sine wave", eff: "95%", cycles: "5,000+", ip: "IP44", dims: "460 × 340 × 420", weight: "44 kg", warranty: "15 years" },
  },
  {
    model: "GP5000", kw: 5, usd: 3606.58, use: "Commercial offices / clinics", budget: "2k_5k", maxUsd: 250,
    img: "/images/gp5000.jpg", pdf: "/datasheets/gp5000.pdf", pvUsd: 1150,
    specs: { rated: "5,000 W", peak: "10,000 W", battery: "5,324 Wh", chem: "LiFePO4", voltage: "51.2 V", charge: "≤ 2 h", wave: "Pure sine wave", eff: "95%", cycles: "5,000+", ip: "IP44", dims: "580 × 450 × 460", weight: "68 kg", warranty: "15 years" },
  },
  {
    model: "GP10K", kw: 10, usd: 7681.09, use: "Manufacturing / hotels / cold storage", budget: "5k_15k", maxUsd: 600,
    img: "/images/gp10k.jpg", pdf: "/datasheets/gp10k.pdf", pvUsd: 2200,
    specs: { rated: "10,000 W", peak: "20,000 W", battery: "10 / 15 kWh", chem: "LiFePO4", voltage: "51.2 V", charge: "≤ 5 h", wave: "Pure sine wave", eff: "95%", cycles: "5,000+", ip: "IP44", dims: "930 × 703 × 1000", weight: "107 kg", warranty: "15 years" },
  },
  {
    model: "GP20K", kw: 20, usd: 16443.68, use: "Heavy industry / surge buffering", budget: "15k_plus", maxUsd: Infinity,
    img: "/images/gp20k.jpg", pdf: "/datasheets/gp20k.pdf", flagship: true, pvUsd: 4200,
    specs: { rated: "20,000 W", peak: "40,000 W", battery: "30 kWh", chem: "LiFePO4", voltage: "51.2 V", charge: "≈ 5 h", wave: "Pure sine wave", eff: "95%", cycles: "5,000+", ip: "IP44", dims: "1000 × 650 × 1150", weight: "276 kg", warranty: "15 years" },
  },
];

// Spec comparison schema (bilingual labels) — order drives the comparison table rows.
export const SPEC_ROWS = [
  { key: "rated", en: "Rated power", fr: "Puissance nominale" },
  { key: "peak", en: "Peak power", fr: "Puissance de crête" },
  { key: "battery", en: "Battery capacity", fr: "Capacité batterie" },
  { key: "chem", en: "Battery chemistry", fr: "Chimie batterie" },
  { key: "voltage", en: "Battery voltage", fr: "Tension batterie" },
  { key: "charge", en: "Charging time", fr: "Temps de charge" },
  { key: "wave", en: "Output waveform", fr: "Onde de sortie" },
  { key: "eff", en: "Peak efficiency", fr: "Rendement crête" },
  { key: "cycles", en: "Cycle life", fr: "Durée de vie" },
  { key: "ip", en: "Ingress rating", fr: "Indice IP" },
  { key: "dims", en: "Dimensions (mm)", fr: "Dimensions (mm)" },
  { key: "weight", en: "Net weight", fr: "Poids net" },
  { key: "warranty", en: "Warranty", fr: "Garantie" },
];

// Regional electricity tariffs (approx. USD per kWh) + typical monthly outage baselines
export const REGIONS = [
  { id: "gh", labelEN: "Ghana", labelFR: "Ghana", tariff: 0.11, currency: "GHS", symbol: "₵", fx: 15.2 },
  { id: "ng", labelEN: "Nigeria", labelFR: "Nigéria", tariff: 0.15, currency: "NGN", symbol: "₦", fx: 1600 },
  { id: "ke", labelEN: "Kenya", labelFR: "Kenya", tariff: 0.22, currency: "KES", symbol: "KSh", fx: 129 },
  { id: "sn", labelEN: "Senegal", labelFR: "Sénégal", tariff: 0.20, currency: "XOF", symbol: "CFA", fx: 605 },
  { id: "za", labelEN: "South Africa", labelFR: "Afrique du Sud", tariff: 0.16, currency: "ZAR", symbol: "R", fx: 18.2 },
];

// Quote currencies: USD base + each region's local currency (fx = local units per 1 USD).
export const CURRENCIES = [
  { id: "usd", labelEN: "USD", labelFR: "USD", currency: "USD", symbol: "$", fx: 1 },
  ...REGIONS.map((r) => ({ id: r.id, labelEN: r.labelEN, labelFR: r.labelFR, currency: r.currency, symbol: r.symbol, fx: r.fx })),
];

// Format a USD amount into the chosen currency (whole units, thousands-separated).
export const formatQuote = (usd, cur) => {
  const amount = Math.round(usd * cur.fx);
  const num = amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
  // symbols that read better after the number
  const suffix = ["CFA", "R", "₵", "KSh"].includes(cur.symbol);
  return suffix ? `${num} ${cur.symbol}` : `${cur.symbol}${num}`;
};

// IANA timezone → currency id, used to auto-detect the visitor's local currency.
// Covers the timezones that resolve to each of our supported markets.
export const TZ_TO_CURRENCY = {
  "Africa/Accra": "gh",
  "Africa/Lagos": "ng",
  "Africa/Nairobi": "ke",
  "Africa/Dakar": "sn",
  "Africa/Abidjan": "sn", // West-Africa CFA zone
  "Africa/Bamako": "sn",
  "Africa/Johannesburg": "za",
};

// Heavy-industrial container-scale power storage (custom builds, 40–200 kW).
export const CONTAINER = {
  img: "/images/container.jpg",
  pdf: "/datasheets/container.pdf",
  minKw: 40,
  maxKw: 200,
  highlights: [
    { rated: "40 – 200 kW", label: "Rated power" },
    { rated: "Up to 400 kW", label: "Peak power" },
    { rated: "60 – 300 kWh", label: "Battery storage" },
    { rated: "LiFePO4", label: "Battery chemistry" },
  ],
  // Indicative container model matrix (custom-built to load profile).
  models: [
    { model: "GS-C40", ratedKw: 40, peakKw: 80, kwh: 60, container: "10 ft" },
    { model: "GS-C60", ratedKw: 60, peakKw: 120, kwh: 90, container: "10 ft" },
    { model: "GS-C100", ratedKw: 100, peakKw: 200, kwh: 150, container: "20 ft" },
    { model: "GS-C150", ratedKw: 150, peakKw: 300, kwh: 230, container: "20 ft" },
    { model: "GS-C200", ratedKw: 200, peakKw: 400, kwh: 300, container: "20 ft" },
  ],
  common: [
    { label: "Battery chemistry", value: "LiFePO4 (modular racks)" },
    { label: "Output waveform", value: "Pure sine wave" },
    { label: "Peak efficiency", value: "95%" },
    { label: "Cycle life", value: "6,000+ cycles" },
    { label: "Ingress rating", value: "IP54 enclosure" },
    { label: "Operating temp.", value: "−20 °C to +50 °C" },
    { label: "Grid modes", value: "On-Grid / Off-Grid / Hybrid" },
    { label: "Solar input", value: "MPPT solar-ready" },
  ],
};

// Countries where Gesung is actively recruiting local distributors.
export const DISTRIBUTOR_COUNTRIES = ["Nigeria", "Niger", "Kenya", "Senegal", "Togo", "Benin", "Sierra Leone", "Liberia", "Ivory Coast", "Guinea", "Burkina Faso", "Mali"];

// West-Africa priority cluster, spotlighted on its own zoomed regional map.
export const WEST_AFRICA_COUNTRIES = ["Ivory Coast", "Togo", "Benin", "Burkina Faso", "Mali", "Niger"];

// Map a distributor country to its name in the topojson (for map highlighting).
export const GEO_NAME = { "Ivory Coast": "Côte d'Ivoire" };

// Company contact phone numbers (Ghana).
export const CONTACTS = ["+233 59 610 3334", "+233 24 871 6312", "+233 24 972 8394", "+233 24 390 6758"];

// Team WhatsApp number for one-tap click-to-chat (digits only, intl format).
export const WHATSAPP_NUMBER = "233244634028";

// Product warranties.
export const WARRANTY = { generatorsYears: 15, panelsYears: 30 };

// Support / live-chat business hours (Africa/Accra = GMT+0). Decimal hours, per weekday.
export const SUPPORT_HOURS = {
  tzLabel: "GMT",
  byDay: {
    1: { start: 8.5, end: 19 }, // Mon 8:30am–7pm
    2: { start: 8.5, end: 19 },
    3: { start: 8.5, end: 19 },
    4: { start: 8.5, end: 19 },
    5: { start: 8.5, end: 19 },
    6: { start: 9, end: 14 },   // Sat 9am–2pm
  },
};

// Returns true if the team is currently within business hours (evaluated in GMT).
export const isSupportOnline = (now = new Date()) => {
  const w = SUPPORT_HOURS.byDay[now.getUTCDay()];
  if (!w) return false;
  const h = now.getUTCHours() + now.getUTCMinutes() / 60;
  return h >= w.start && h < w.end;
};

// Ghana 70/30 credit plan: 70% upfront, remaining 30% financed over a chosen term,
// with a flat interest rate on the financed balance that grows with the term.
export const FINANCE = {
  downRate: 0.7,
  financedRate: 0.3,
  terms: [6, 12, 18, 24],
  rates: { 6: 0.15, 12: 0.20, 18: 0.24, 24: 0.30 }, // flat interest on the 30% balance
};
// Upfront cash discount rate by market (currency): Ghana keeps 5%, all other
// markets get 25% off for outright cash payments.
export const upfrontDiscountRate = (curId) => (curId === "gh" ? 0.05 : 0.25);

export const financePlan = (usd, months) => {
  const down = usd * FINANCE.downRate;
  const financed = usd * FINANCE.financedRate;
  const rate = FINANCE.rates[months] ?? 0;
  const totalFinanced = financed * (1 + rate);
  return { down, financed, rate, totalFinanced, monthly: totalFinanced / months, months, total: down + totalFinanced };
};

// Short distributor-opportunity blurbs shown when a country is tapped on the map.
export const COUNTRY_BLURBS = {
  Nigeria: {
    en: "Africa's largest economy with chronic grid shortfalls — huge demand for reliable backup across homes, SMEs and industry.",
    fr: "La plus grande économie d'Afrique, avec un réseau instable — forte demande de secours fiable pour foyers, PME et industrie.",
  },
  Kenya: {
    en: "A fast-growing East-African hub with strong solar adoption and a thriving SME sector ready for clean power storage.",
    fr: "Un pôle est-africain en pleine croissance, forte adoption du solaire et un secteur PME prêt pour le stockage propre.",
  },
  Senegal: {
    en: "Francophone gateway to West Africa with rising commercial demand and supportive renewable-energy policy.",
    fr: "Porte d'entrée francophone de l'Afrique de l'Ouest, demande commerciale croissante et politique favorable au renouvelable.",
  },
  Togo: {
    en: "Compact, high-potential market with growing electrification drives and cross-border trade opportunities.",
    fr: "Marché compact à fort potentiel, électrification en hausse et opportunités de commerce transfrontalier.",
  },
  Benin: {
    en: "Emerging demand from agriculture, cold chains and SMEs — an open field for a first-mover distributor.",
    fr: "Demande émergente de l'agriculture, des chaînes du froid et des PME — un terrain ouvert pour un distributeur pionnier.",
  },
  "Sierra Leone": {
    en: "Low grid coverage and rebuilding infrastructure make reliable storage a fast-growing essential.",
    fr: "Faible couverture du réseau et infrastructures en reconstruction : le stockage fiable devient essentiel.",
  },
  Liberia: {
    en: "One of Africa's lowest electrification rates — vast untapped demand for off-grid clean power.",
    fr: "L'un des plus faibles taux d'électrification d'Afrique — une immense demande inexploitée pour le hors-réseau.",
  },
  "Ivory Coast": {
    en: "West Africa's fastest-growing economy with booming industry and construction — prime commercial demand.",
    fr: "L'économie à la croissance la plus rapide d'Afrique de l'Ouest : industrie et construction en plein essor.",
  },
  Guinea: {
    en: "Mining-driven economy needing heavy-duty, uninterrupted power — ideal for our industrial range.",
    fr: "Économie minière nécessitant une énergie robuste et continue — idéale pour notre gamme industrielle.",
  },
  "Burkina Faso": {
    en: "High solar irradiation and frequent outages create strong demand for solar-backed storage.",
    fr: "Fort ensoleillement et coupures fréquentes : forte demande de stockage adossé au solaire.",
  },
  Mali: {
    en: "Abundant sun and expanding rural electrification open a wide runway for solar power storage.",
    fr: "Soleil abondant et électrification rurale en expansion : un vaste potentiel pour le stockage solaire.",
  },
  Niger: {
    en: "Vast Sahelian market with very low grid access and intense sunshine — strong demand for reliable off-grid solar storage.",
    fr: "Vaste marché sahélien à très faible accès au réseau et fort ensoleillement — forte demande de stockage solaire hors-réseau fiable.",
  },
};
